module.exports = __webpack_public_path__ + "static/media/swingometer.d9bb6433.gif";